import { render, staticRenderFns } from "./SecondMonthFreeBenefitNotificationBox.vue?vue&type=template&id=2a275348&scoped=true&"
import script from "./SecondMonthFreeBenefitNotificationBox.vue?vue&type=script&lang=js&"
export * from "./SecondMonthFreeBenefitNotificationBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a275348",
  null
  
)

export default component.exports